class OpenGorgiasWidget extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()
    this.setupListeners()
  }

  setupListeners () {
    super.setupListeners()

    this.listeners.add(this, 'click', this.handleShow)

    const closeWidgetParent = this.parentElement
    const closeWidgetParentTrigger = closeWidgetParent.querySelector('close-gorgias-widget')

    closeWidgetParentTrigger.addEventListener('click', this.handleClose)
  }

  async handleClose (event) {
    GorgiasChat.close()

    this.classList.remove('is-active')
    this.classList.add('is-hidden')
  }

  async handleShow (event) {
    GorgiasChat.open()

    const closeWidgetParent = event.target.parentElement
    const closeWidgetParentTrigger = closeWidgetParent.querySelector('close-gorgias-widget')

    closeWidgetParentTrigger.classList.remove('is-hidden')
    closeWidgetParentTrigger.classList.add('is-active')
  }
}

if (!customElements.get('open-gorgias-widget')) {
  customElements.define('open-gorgias-widget', OpenGorgiasWidget)
}
